var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.3 0 0 6.3 0 14C0 21.7 6.3 28 14 28C21.7 28 28 21.7 28 14C28 6.3 21.7 0 14 0ZM19.18 14.98C18.62 15.54 17.78 15.54 17.22 14.98L15.4 13.16V18.2C15.4 19.04 14.84 19.6 14 19.6C13.16 19.6 12.6 19.04 12.6 18.2V13.16L10.78 14.98C10.22 15.54 9.38 15.54 8.82 14.98C8.26 14.42 8.26 13.58 8.82 13.02L13.02 8.82C13.58 8.26 14.42 8.26 14.98 8.82L19.18 13.02C19.74 13.58 19.74 14.42 19.18 14.98Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.937d94a1e2372060e4511194f0725a95.svg";
export { ForwardRef as ReactComponent };